export default "__VITE_ASSET__7548154f__"